import React from "react";
import Joyride, { CallBackProps, STATUS, Step } from "react-joyride";

type OnboardingProps = {
  startOnboarding: boolean;
  setStartOnboarding: (startOnboarding: boolean) => void;
};

export function Onboarding({
  startOnboarding,
  setStartOnboarding,
}: OnboardingProps) {
  const onboardingSteps: Step[] = [
    {
      target: "#app-title",
      title: "Missouri Time Served Calculator",
      content:
        "Understand the possible range of time served for any charge and sentence imposed.",
      disableBeacon: true,
    },
    {
      target: "#charge-code",
      title: "Select Charge Code",
      content:
        "Once selected, view the corresponding charge code description, felony class, offense type, and relevant sentencing laws.",
      disableBeacon: true,
    },
    {
      target: "#inputs",
      title: "Inputs",
      content:
        "Enter a sentence imposed (in years) and jail time credited (in months) to see the range of time to be served, based on state sentencing laws.",
      disableBeacon: true,
    },
    {
      target: "#timeline",
      title: "Time Served",
      content:
        "Visualize projected time served based on the sentence imposed selected for the charge.",
      disableBeacon: true,
    },
    {
      target: "#rules",
      title: "Relevant Rules",
      content:
        "Understand sentencing laws that inform the time served range for a charge and sentence imposed.",
      disableBeacon: true,
    },
  ];

  const handleCompleteOnboarding = (data: CallBackProps) => {
    const { status } = data;
    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      setStartOnboarding(false);
    }
  };

  return (
    <Joyride
      run={startOnboarding}
      steps={onboardingSteps}
      continuous
      showProgress
      callback={handleCompleteOnboarding}
      hideCloseButton
      showSkipButton
      locale={{ last: "Done" }}
      styles={{
        options: {
          primaryColor: '#b30000',
        },
        tooltipContent: {
          textAlign: 'left', // Left align the content
        },
        tooltipTitle: {
          textAlign: 'center', // Keep the title centered
        },
      }}
    />
  );
}
